import { StemSplitGroupType, StemType } from "@/types/defs/stemSplit";

export const STEM_TYPES = [
  "vocals",
  "drums",
  "bass",
  "other",
  "instrumental",
] as const;

export const STEM_TYPE_DISPLAY_NAMES: Record<StemType, string> = {
  vocals: "Vocals",
  drums: "Drums",
  bass: "Bass",
  other: "Other",
  instrumental: "Instrumental",
} as const;

export const STEM_SPLIT_GROUP_TYPES = [
  "drumsBass",
  "vocalsInstrumental",
] as const;

export const STEM_SPLIT_GROUP = {
  DrumsBass: "drumsBass",
  VocalsInstrumental: "vocalsInstrumental",
} as const satisfies Record<
  "DrumsBass" | "VocalsInstrumental",
  StemSplitGroupType
>;

export const STEM_SPLIT_GROUP_COMBINATIONS: Readonly<
  Record<StemSplitGroupType, readonly StemType[]>
> = {
  drumsBass: ["vocals", "drums", "bass", "other"],
  vocalsInstrumental: ["vocals", "instrumental"],
} as const;

export const EXPECTED_STEMS_COUNT = {
  [STEM_SPLIT_GROUP.DrumsBass]: STEM_SPLIT_GROUP_COMBINATIONS.drumsBass.length,
  [STEM_SPLIT_GROUP.VocalsInstrumental]:
    STEM_SPLIT_GROUP_COMBINATIONS.vocalsInstrumental.length,
} as const;

export const isValidStemForGroup = (
  stem: StemType,
  group: StemSplitGroupType
): boolean => {
  return STEM_SPLIT_GROUP_COMBINATIONS[group].includes(stem);
};

export const STEM_SPLIT_GROUP_OPTION_LABELS = [
  {
    value: STEM_SPLIT_GROUP.DrumsBass,
    title: `${EXPECTED_STEMS_COUNT[STEM_SPLIT_GROUP.DrumsBass]}-Stem separation`,
    description: STEM_SPLIT_GROUP_COMBINATIONS.drumsBass
      .map((s) => STEM_TYPE_DISPLAY_NAMES[s])
      .join(", "),
  },
  {
    value: STEM_SPLIT_GROUP.VocalsInstrumental,
    title: `${EXPECTED_STEMS_COUNT[STEM_SPLIT_GROUP.VocalsInstrumental]}-Stem separation`,
    description: STEM_SPLIT_GROUP_COMBINATIONS.vocalsInstrumental
      .map((s) => STEM_TYPE_DISPLAY_NAMES[s])
      .join(", "),
  },
] as const;
